export const MAX_FILE_SIZE = 2000000;
export const SP_MAX_FILE_SIZE = 1000000;
export const SP_MAX_FILES_LIMIT = 5;
export const DEFAULT_PAGE_NO: number = 1;

export const VALID_FILE_EXTENSIONS = [
    'pdf',
    'doc',
    'docx',
    'ppt',
    'pptx',
    'jpg',
    'jpeg',
    'png',
    'mp4',
    'avi',
    'mkv',
];
export const DOCUMENT_EXTENSIONS = ['pdf', 'doc', 'docx', 'ppt', 'pptx'];
export const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png'];
export const VIDEO_EXTENSIONS = ['mp4', 'avi', 'mkv'];

export const VALID_FILE_TYPES = [
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.ms-powerpoint',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
];
export const DOCUMENT_FIELD = {
    FileName: 'name',
    FileStatus: 'status',
    FileSize: 'size',
    FileCreatedOn: 'createdAt',
    FileLastSyncedOn: 'lastSyncedOn',
};
export const SORTING_ORDER = {
    ASC: 'asc',
    DESC: 'desc',
};
export const FOLDER_POLL_SECS = 60;
export const PREV_SELECTED_FOLDER = 'prevSelectedFolder';
export const contentSourceType = ['ginger-document-hub', 'share-point'];
export const DOCUMENT_HUB = 'documenthub';
export const SHAREPOINT = 'sharepoint';
export const gingerDocumentHubTranslation = {
    sourceName: 'Ginger Document Hub',
    dialog: {
        title: 'kb.create.dialog.title',
        blankValidation: 'kb.create.dialog.namespace.error',
        regexValidation: 'kb.create.dialog.validation.error1',
        periodValidation: 'kb.create.dialog.validation.error2',
        inputLabel: 'kb.create.dialog.name.label',
    },
    UploadPanel: {
        title: 'kb.doc.upload.start.title',
        subTitle: 'kb.doc.upload.start.subtitle',
    },
    noFolder: {
        title: 'kb.no-folders.title',
        subTitle: 'kb.no-folders.subtitle',
        buttonLabel: 'kb.create.folder',
    },
};

export const sharePointTranslation = {
    sourceName: 'SharePoint',
    dialog: {
        title: 'kb.sharePoint.create.dialog.title',
        blankValidation: 'kb.sharePoint.create.dialog.namespace.error',
        regexValidation: 'kb.sharePoint.create.dialog.validation.error1',
        periodValidation: 'kb.sharePoint.create.dialog.validation.error2',
        inputLabel: 'kb.labels.folders',
    },
    UploadPanel: {
        title: 'kb.sharePoint.upload.start.title',
        subTitle: 'kb.sharepoint.upload.start.subtitle',
    },
    noFolder: {
        title: 'kb.no-k-repos.title',
        subTitle: 'kb.no-k-repos.subtitle',
        buttonLabel: 'kb.create',
    },
};

export const ContentActionsList = [
    // { value: 'view', label: 'action.contentSource.view', icon: '' },
    { value: 'disconnect', label: 'action.contentSource.disconnect', icon: '' },
];

export const NewSharepointSourceConfig = {
    id: '',
    sharepointConfigId: '',
    name: 'Sharepoint',
    siteId: '',
};
export const SPListBreadcrumbsPath = [
    {
        name: 'Lists',
    },
];
export const FileTypeSizeList = [
    { type: 'xls', size: '50 MB' },
    { type: 'xlsx', size: '50 MB' },
    { type: 'doc', size: '50 MB' },
    { type: 'docx', size: '50 MB' },
    { type: 'ppt', size: '50 MB' },
    { type: 'pptx', size: '50 MB' },
    { type: 'pdf', size: '50 MB' },
    { type: 'jpg', size: '50 MB' },
    { type: 'jpeg', size: '50 MB' },
    { type: 'png', size: '50 MB' },
    { type: 'mp4', size: '500 MB' },
    { type: 'avi', size: '500 MB' },
    { type: 'mkv', size: '500 MB' },
];
export enum EntityType {
    LegalEntities = 'legalEntities',
    UserGroups = 'userGroups',
}

export enum UserSelectOptionsType {
    GEN_SEARCH = 'gensearch',
    ORG_SEARCH = 'orgsearch',
    IT_SHOP = 'itshop',
    NORMATIVE = 'normative',
    SABIO = 'sabio',
}
export const Norman = 'norman';

export const DEEP_THINK_ALLOWED_OPTIONS = [
    UserSelectOptionsType.GEN_SEARCH,
    UserSelectOptionsType.ORG_SEARCH,
];
export interface UserSelectionOptionsType {
    value: string;
    label: string;
    description: string;
}
export const UserSelectionOptions: UserSelectionOptionsType[] = [
    {
        value: UserSelectOptionsType.GEN_SEARCH,
        label: 'input_field.form.option1.label',
        description: 'input_field.form.option1.description',
    },
    {
        value: UserSelectOptionsType.ORG_SEARCH,
        label: 'input_field.form.option2.label',
        description: 'input_field.form.option2.description',
    },
    // {
    //     value: UserSelectOptionsType.IT_SHOP,
    //     label: 'input_field.form.option3.label',
    //     description: 'input_field.form.option3.description',
    // },
    {
        value: UserSelectOptionsType.NORMATIVE,
        label: 'input_field.form.option4.label',
        description: 'input_field.form.option4.description',
    },
    {
        value: UserSelectOptionsType.SABIO,
        label: 'input_field.form.option5.label',
        description: 'input_field.form.option5.description',
    },
];
